import { ddlClientInitialise } from 'slim-select-prefabs'

interface concern {
	accountManager: string
	clientID: 9526
	clientName: string;
	concernsIssues: string;
	contractAmount: number;
	contractPeriod: string
	contractRenewalDate: string
	palomaEmployeeID: number
	product: string
	productGroup: string
	productGroupID: number
	productID: number
}

const issuesConcernsDataTableInitialise = () => {
	new JSTable('#IssuesConcernsTable', {
		labels: {
			loading: 'Loading...',
			noRows: 'No data available in table'
		},
		perPage: 20,
		perPageSelect: false
	})
}
const issuesConcernsInitialise = () => {
	const clientID = document.querySelector('.ddlClientID') as HTMLFormElement
	const productGroupID = document.querySelector('.ddlProductGroupID') as HTMLFormElement
	const productID = document.querySelector('.ddlProductID') as HTMLFormElement
	const contractPeriod = document.querySelector('.ddlContractPeriod') as HTMLFormElement
	const palomaEmployeeID = document.querySelector('.ddlPalomaEmployeeID') as HTMLFormElement
	const hidGetClientIssuesConcernsList = document.getElementById(
		'hidGetClientIssuesConcernsList'
	) as HTMLFormElement
	const hidViewClient = document.getElementById('hidViewClient') as HTMLFormElement
	fetch(
		`${hidGetClientIssuesConcernsList.value.toString()}?ClientID=${encodeURIComponent(
			clientID.value.toString()
		)}&ProductGroupID=${encodeURIComponent(
			productGroupID.value.toString()
		)}&ProductID=${encodeURIComponent(
			productID.value.toString()
		)}&ContractPeriod=${encodeURIComponent(
			contractPeriod.value.toString()
		)}&PalomaEmployeeID=${encodeURIComponent(palomaEmployeeID.value.toString())}`,
		{
			method: 'POST'
		}
	)
		.then((response) => response.json())
		.then((result) => {
			const tableId = document.getElementById('IssuesConcernsTable') as HTMLTableElement
			let tBody = tableId.getElementsByTagName('tbody')[0]
			if (tBody !== undefined) {
				tableId.removeChild(tBody)
			}
			tableId.appendChild(document.createElement('tbody'))
			tBody = tableId.getElementsByTagName('tbody')[0] as HTMLTableSectionElement
			result.forEach((elem: concern) => {
				tBody.insertAdjacentHTML(
					'beforeend',
					`<tr><td><a href='${hidViewClient.value.toString()}/${elem.clientID}'>${
						elem.clientName
					}</a></td><td>${elem.product}</td><td>${elem.productGroup}</td><td>${
						elem.contractPeriod
					}</td><td>${elem.contractRenewalDate}</td><td>${elem.contractAmount}</td><td>${
						elem.accountManager
					}</td><td>${elem.concernsIssues}</td></tr>`
				)
			})
			issuesConcernsDataTableInitialise()
		})
}

const initialise = () => {
	ddlClientInitialise()
	issuesConcernsInitialise()
	const ddlLogClientID = document.querySelector('.ddlLogClientID') as HTMLFormElement
	if (ddlLogClientID != null) {
		ddlLogClientID.addEventListener('change', () => {
			issuesConcernsInitialise()
		})
	}
	const ddlProductGroupID = document.querySelector('.ddlProductGroupID') as HTMLFormElement
	if (ddlProductGroupID != null) {
		ddlProductGroupID.addEventListener('change', () => {
			issuesConcernsInitialise()
		})
	}
	const ddlProductID = document.querySelector('.ddlProductID') as HTMLFormElement
	if (ddlProductID != null) {
		ddlProductID.addEventListener('change', () => {
			issuesConcernsInitialise()
		})
	}
	const ddlContractPeriod = document.querySelector('.ddlContractPeriod') as HTMLFormElement
	if (ddlContractPeriod != null) {
		ddlContractPeriod.addEventListener('change', () => {
			issuesConcernsInitialise()
		})
	}
	const ddlPalomaEmployeeID = document.querySelector('.ddlPalomaEmployeeID') as HTMLFormElement
	if (ddlPalomaEmployeeID != null) {
		ddlPalomaEmployeeID.addEventListener('change', () => {
			issuesConcernsInitialise()
		})
	}
}
window.addEventListener('load', () => {
	initialise()
})
